import { SET_LOOKUP_DATA } from "../actions/lookupDataActions";


const defaultState = {
    lookupData: []
}

export const lookupDataReducer = (state = defaultState, action: any) => {
    const { type, data } = action;
    if (type === SET_LOOKUP_DATA) return { ...state, lookupData: data };
    return state;
}